(function () {
  "use strict";
  if (window.SAECollectionEffects && window.SAECollectionEffects.version === 4) {
    window.SAECollectionEffects.initialize();
    return;
  }
  var bindings = new WeakMap();
  var touchCards = new Set();
  var inputMode = "keyboard";
  function resetTouchOutside(target, immediate) {
    touchCards.forEach(function (record) {
      if (!target || !record.card.contains(target)) record.resetTouch(immediate);
    });
  }
  if ("PointerEvent" in window) {
    document.addEventListener("pointerdown", function (event) {
      inputMode = event.pointerType || "mouse";
      resetTouchOutside(inputMode === "touch" ? event.target : null, false);
    }, { capture: true, passive: true });
  } else {
    document.addEventListener("touchstart", function (event) {
      inputMode = "touch"; resetTouchOutside(event.target, false);
    }, { capture: true, passive: true });
  }
  document.addEventListener("keydown", function () { inputMode = "keyboard"; resetTouchOutside(null, true); }, true);
  document.addEventListener("scroll", function () { resetTouchOutside(null, true); }, { capture: true, passive: true });
  document.addEventListener("visibilitychange", function () { if (document.hidden) resetTouchOutside(null, true); });
  window.addEventListener("pagehide", function () { resetTouchOutside(null, true); });
  function bind(card) {
    var image = card.querySelector(".sae-card-model-photo");
    var flash = card.querySelector(".sae-card-white-flash");
    var link = card.querySelector(".link-block-2");
    var hint = card.querySelector("[data-sae-touch-hint]");
    var previous = bindings.get(card);
    if (previous && previous.image === image && previous.flash === flash && previous.link === link && previous.hint === hint) return;
    if (previous) previous.cleanup();
    var listeners = [], frame = 0, generation = 0;
    var over = false;
    var touchActive = false;
    var touchEnabled = card.dataset.saeComingSoon === "true" && card.dataset.saeGray === "true" && card.dataset.saeTouchPreview !== "false";
    var focused = inputMode !== "touch" && !!(document.activeElement && card.contains(document.activeElement));
    var failed = !!(image && image.complete && image.naturalWidth === 0);
    var current = { model: false, revealed: false }, pending = null;
    var motion = window.matchMedia ? window.matchMedia("(prefers-reduced-motion: reduce)") : null;
    var coarsePointer = window.matchMedia ? window.matchMedia("(any-pointer: coarse)") : null;
    try { over = inputMode !== "touch" && card.matches(":hover"); } catch (_) { /* Events support older selector engines. */ }
    function listen(target, name, handler) {
      target.addEventListener(name, handler);
      listeners.push(function () { target.removeEventListener(name, handler); });
    }
    function same(a, b) { return !!a && !!b && a.model === b.model && a.revealed === b.revealed; }
    function stop() {
      generation++;
      if (frame) cancelAnimationFrame(frame);
      frame = 0; pending = null;
      if (flash) flash.style.opacity = "0";
    }
    function apply(next) {
      current = next;
      card.dataset.saePreviewActive = String(next.model);
      card.dataset.saeRevealed = String(next.revealed);
    }
    function transition(next, immediate) {
      var useFlash = !!(flash && card.dataset.saeWhiteFlash === "true" && !(motion && motion.matches));
      card.dataset.saeFlashManaged = String(useFlash);
      if (immediate) { stop(); apply(next); return; }
      if (same(next, pending)) return;
      if (same(next, current)) { stop(); return; }
      stop();
      if (!useFlash) { apply(next); return; }
      pending = next;
      var token = generation;
      var rawDuration = parseFloat(getComputedStyle(card).getPropertyValue("--sae-model-fade"));
      var duration = Number.isFinite(rawDuration) ? Math.max(100, Math.min(500, rawDuration)) : 180;
      var coverDuration = duration * 0.4;
      var revealDuration = duration - coverDuration;
      var started = performance.now();
      function uncover(start) {
        frame = requestAnimationFrame(function reveal(now) {
          if (token !== generation || !card.isConnected) return;
          var fraction = Math.max(0, Math.min(1, (now - start) / revealDuration));
          flash.style.opacity = String(Math.pow(1 - fraction, 2));
          if (fraction < 1) frame = requestAnimationFrame(reveal);
          else { frame = 0; pending = null; flash.style.opacity = "0"; }
        });
      }
      frame = requestAnimationFrame(function cover(now) {
        if (token !== generation || !card.isConnected) return;
        var fraction = Math.max(0, Math.min(1, (now - started) / coverDuration));
        flash.style.opacity = String(1 - Math.pow(1 - fraction, 2));
        if (fraction < 1) frame = requestAnimationFrame(cover);
        else {
          // Paint a fully white frame; swap underneath it, then reveal the new photo.
          flash.style.opacity = "1";
          apply(next);
          uncover(now);
        }
      });
    }
    function update(immediate) {
      var active = over || focused || touchActive;
      var ready = !!(image && !failed && image.complete && image.naturalWidth > 0);
      if (active && image && !failed && !ready) {
        image.loading = "eager";
        // One flash after the model is ready, instead of flashing twice during a slow load.
        transition({ model: false, revealed: false }, !!immediate);
        return;
      }
      transition({ model: active && ready, revealed: active }, !!immediate);
    }
    function enter(event) {
      if (event.pointerType === "touch") return;
      if (!event.pointerType && inputMode === "touch") return;
      inputMode = event.pointerType || "mouse";
      if (touchActive) { touchActive = false; touchCards.delete(record); updateHint(); }
      over = true; update(false);
    }
    function leave() { over = false; update(false); }
    if ("PointerEvent" in window) {
      listen(card, "pointerenter", enter);
      listen(card, "pointerleave", leave);
      listen(card, "pointercancel", leave);
    } else {
      listen(card, "mouseenter", enter);
      listen(card, "mouseleave", leave);
    }
    listen(card, "focusin", function () { focused = inputMode !== "touch"; update(false); });
    listen(card, "focusout", function (event) {
      focused = !!(event.relatedTarget && card.contains(event.relatedTarget)); update(false);
    });
    function updateHint() {
      card.dataset.saeTouchActive = String(touchActive);
      if (!hint) return;
      hint.hidden = !(touchEnabled && link && ((coarsePointer && coarsePointer.matches) || touchActive || inputMode === "touch"));
      hint.textContent = touchActive ? "Tap again to open" : "Tap to preview";
    }
    var record = {
      card: card, image: image, flash: flash, link: link, hint: hint,
      resetTouch: function (immediate) {
        touchActive = false; touchCards.delete(record);
        over = false; focused = inputMode === "keyboard" && !!(document.activeElement && card.contains(document.activeElement));
        updateHint(); update(!!immediate);
      },
      cleanup: function () { touchCards.delete(record); stop(); listeners.forEach(function (remove) { remove(); }); }
    };
    if (link) listen(link, "click", function (event) {
      var touchClick = event.pointerType ? event.pointerType === "touch" : inputMode === "touch";
      if (!touchEnabled || !touchClick || event.detail === 0 || event.defaultPrevented ||
          (event.button !== undefined && event.button !== 0) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey ||
          link.getAttribute("download") !== null || (link.getAttribute("target") && link.getAttribute("target") !== "_self")) return;
      if (touchActive) return; // The second tap follows the original product link, even while its image is still loading.
      event.preventDefault();
      resetTouchOutside(card, false);
      touchActive = true; over = false; focused = false;
      card.dataset.saeTouchActive = "true";
      touchCards.add(record); updateHint(); update(false);
    });
    if (image) {
      listen(image, "load", function () { failed = false; update(false); });
      listen(image, "error", function () { failed = true; update(true); });
    }
    if (motion && motion.addEventListener) listen(motion, "change", function () { update(true); });
    if (coarsePointer && coarsePointer.addEventListener) listen(coarsePointer, "change", updateHint);
    bindings.set(card, record);
    updateHint();
    update(true);
  }
  function initialize() { document.querySelectorAll("[data-sae-product-card]").forEach(bind); }
  window.SAECollectionEffects = { version: 4, initialize: initialize };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initialize, { once: true });
  else initialize();
  document.addEventListener("shopify:section:load", initialize);
  document.addEventListener("shopify:section:reorder", initialize);
  if (typeof MutationObserver !== "undefined" && document.documentElement) {
    var queued = false;
    new MutationObserver(function (changes) {
      if (!changes.some(function (change) { return change.addedNodes.length || change.removedNodes.length; }) || queued) return;
      queued = true;
      requestAnimationFrame(function () { queued = false; initialize(); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
